import React from "react";
const AuthCardRight = props => {
  return (
    <div> 
      {props.children}
    </div>
  );
};

export default AuthCardRight;